$(document).ready(function () {
  kycount = 0;

  $(".ky_custom_gallery_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + kycount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          kycount +
          '"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50148 0.666716C2.39386 0.555288 2.26512 0.466409 2.12278 0.405265C1.98045 0.344121 1.82736 0.311937 1.67245 0.310591C1.51754 0.309245 1.36391 0.338763 1.22053 0.397425C1.07715 0.456086 0.946892 0.542714 0.83735 0.652256C0.727809 0.761797 0.641181 0.892057 0.58252 1.03544C0.523859 1.17882 0.494341 1.33244 0.495687 1.48735C0.497033 1.64226 0.529216 1.79535 0.59036 1.93769C0.651504 2.08003 0.740383 2.20876 0.851812 2.31638L7.71065 9.17522C7.92936 9.394 8.05223 9.69069 8.05223 10.0001C8.05223 10.3094 7.92936 10.6061 7.71065 10.8249L0.850644 17.6837C0.631885 17.9026 0.509049 18.1995 0.509158 18.509C0.509268 18.8184 0.632315 19.1152 0.851229 19.334C1.07014 19.5527 1.36699 19.6756 1.67647 19.6755C1.98596 19.6753 2.28272 19.5523 2.50148 19.3334L11.01 10.8249C11.2287 10.6061 11.3516 10.3094 11.3516 10.0001C11.3516 9.69069 11.2287 9.394 11.01 9.17522L2.50148 0.666716Z" fill="#202E52"/></svg></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          kycount +
          '"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.85008 0.35617C8.95771 0.244741 9.08644 0.155862 9.22878 0.094718C9.37112 0.0335742 9.52421 0.00139017 9.67912 4.40495e-05C9.83402 -0.00130207 9.98765 0.0282166 10.131 0.0868777C10.2744 0.145539 10.4047 0.232167 10.5142 0.341709C10.6238 0.45125 10.7104 0.581511 10.769 0.72489C10.8277 0.868269 10.8572 1.0219 10.8559 1.1768C10.8545 1.33171 10.8223 1.4848 10.7612 1.62714C10.7001 1.76948 10.6112 1.89822 10.4998 2.00584L3.64092 8.86467C3.4222 9.08345 3.29933 9.38015 3.29933 9.6895C3.29933 9.99886 3.4222 10.2956 3.64092 10.5143L10.5009 17.3732C10.7197 17.5921 10.8425 17.8889 10.8424 18.1984C10.8423 18.5079 10.7192 18.8047 10.5003 19.0234C10.2814 19.2422 9.98457 19.365 9.67509 19.3649C9.36561 19.3648 9.06884 19.2418 8.85008 19.0228L0.341584 10.5143C0.122868 10.2956 0 9.99886 0 9.6895C0 9.38015 0.122868 9.08345 0.341584 8.86467L8.85008 0.35617Z" fill="#202E52"/></svg></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + kycount, {
      spaceBetween: 0,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });

  $(".ky_custom_gallery_mobile_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + kycount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          kycount +
          '"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.50148 0.666716C2.39386 0.555288 2.26512 0.466409 2.12278 0.405265C1.98045 0.344121 1.82736 0.311937 1.67245 0.310591C1.51754 0.309245 1.36391 0.338763 1.22053 0.397425C1.07715 0.456086 0.946892 0.542714 0.83735 0.652256C0.727809 0.761797 0.641181 0.892057 0.58252 1.03544C0.523859 1.17882 0.494341 1.33244 0.495687 1.48735C0.497033 1.64226 0.529216 1.79535 0.59036 1.93769C0.651504 2.08003 0.740383 2.20876 0.851812 2.31638L7.71065 9.17522C7.92936 9.394 8.05223 9.69069 8.05223 10.0001C8.05223 10.3094 7.92936 10.6061 7.71065 10.8249L0.850644 17.6837C0.631885 17.9026 0.509049 18.1995 0.509158 18.509C0.509268 18.8184 0.632315 19.1152 0.851229 19.334C1.07014 19.5527 1.36699 19.6756 1.67647 19.6755C1.98596 19.6753 2.28272 19.5523 2.50148 19.3334L11.01 10.8249C11.2287 10.6061 11.3516 10.3094 11.3516 10.0001C11.3516 9.69069 11.2287 9.394 11.01 9.17522L2.50148 0.666716Z" fill="#202E52"/></svg></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          kycount +
          '"><svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.85008 0.35617C8.95771 0.244741 9.08644 0.155862 9.22878 0.094718C9.37112 0.0335742 9.52421 0.00139017 9.67912 4.40495e-05C9.83402 -0.00130207 9.98765 0.0282166 10.131 0.0868777C10.2744 0.145539 10.4047 0.232167 10.5142 0.341709C10.6238 0.45125 10.7104 0.581511 10.769 0.72489C10.8277 0.868269 10.8572 1.0219 10.8559 1.1768C10.8545 1.33171 10.8223 1.4848 10.7612 1.62714C10.7001 1.76948 10.6112 1.89822 10.4998 2.00584L3.64092 8.86467C3.4222 9.08345 3.29933 9.38015 3.29933 9.6895C3.29933 9.99886 3.4222 10.2956 3.64092 10.5143L10.5009 17.3732C10.7197 17.5921 10.8425 17.8889 10.8424 18.1984C10.8423 18.5079 10.7192 18.8047 10.5003 19.0234C10.2814 19.2422 9.98457 19.365 9.67509 19.3649C9.36561 19.3648 9.06884 19.2418 8.85008 19.0228L0.341584 10.5143C0.122868 10.2956 0 9.99886 0 9.6895C0 9.38015 0.122868 9.08345 0.341584 8.86467L8.85008 0.35617Z" fill="#202E52"/></svg></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + kycount, {
      spaceBetween: 0,
      lazy: true,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });

  $(".ky_custom_gallery_with_hover_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + kycount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          kycount +
          '"></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          kycount +
          '"></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + kycount, {
      spaceBetween: 0,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });

  $(".ky_custom_testimonial_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    var currentCount = kycount;
    this_item.addClass("swiper customswiper3" + kycount);

    this_item.append(
      '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
        kycount +
        '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
        kycount +
        '"></div>'
    );
    this_item.append(
      '<div class="swiper-pagination testimonials_pagination' +
        currentCount +
        '"></div>'
    );

    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");

    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");

    var partner_swiper = new Swiper(".customswiper3" + kycount, {
      spaceBetween: 0,
      navigation: {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      },
      pagination: {
        el: ".swiper-pagination.testimonials_pagination" + currentCount,
        type: "bullets",
        clickable: true,
      },
      on: {
        slideChange: function () {
          setTimeout(() => {
            updatePaginationBullets(currentCount);
          }, 50);
        },
        init: function () {
          setTimeout(() => {
            updatePaginationBullets(currentCount);
          }, 50);
        },
      },
      loop: false,
      autoplay: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: 15,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: 30,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: 60,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: 60,
        },
      },
    });
    function updatePaginationBullets(count) {
      const bullets = document.querySelectorAll(
        ".testimonials_pagination" + count + " .swiper-pagination-bullet"
      );
      const activeIndex = [...bullets].findIndex((b) =>
        b.classList.contains("swiper-pagination-bullet-active")
      );

      bullets.forEach((bullet, i) => {
        bullet.classList.remove(
          "swiper-pagination-bullet-nearby",
          "swiper-pagination-bullet-far"
        );

        const distance = Math.abs(activeIndex - i);

        if (distance === 1) {
          bullet.classList.add("swiper-pagination-bullet-nearby");
        } else if (distance >= 2) {
          bullet.classList.add("swiper-pagination-bullet-far");
        }
      });
    }
  });
});

//  Swatch initializer function
function initializeSwatches($scope = $(document)) {
  $scope.find(".card-wrapper .color-swatches").each(function () {
    $(this)
      .find(".adc--ctn")
      .each(function () {
        if (!$(this).attr("aria-haspopup")) {
          this.setAttribute("aria-haspopup", "dialog");
        }
      });

    var $firstLabel = $(this).find(".swatch-label").first();
    if (!$firstLabel.length) return;

    var selectedColor = $firstLabel.find(".swatch").attr("title");
    var productWishlistbutton = $(this)
      .closest(".card-wrapper")
      .find(".wishlist_button");

    if (productWishlistbutton.length) {
      productWishlistbutton.attr("data-selected-variant-value", selectedColor);
    }

    $firstLabel.addClass("active");
    $firstLabel.find(".swatch-radio").prop("checked", true);
    $firstLabel.trigger("click");
  });
}

// ✅ Wait for swatches to load before initializing
function waitForSwatchesToLoad(retries = 10, $scope = $(document)) {
  const $swatches = $scope.find(".card-wrapper .color-swatches .swatch-label");

  if ($swatches.length) {
    setTimeout(() => initializeSwatches($scope), 50);
  } else if (retries > 0) {
    setTimeout(() => waitForSwatchesToLoad(retries - 1, $scope), 100);
  }
}

//  On document ready
$(document).ready(function () {
  waitForSwatchesToLoad();
});

//  Re-initialize after Shopify section render (filters)
document.addEventListener("shopify:section:load", (e) => {
  waitForSwatchesToLoad($(e.target));
});

// // ✅ Also support for Shopify Facet Filters (if you're using it)
// document.addEventListener("facet:changed", function () {
//   waitForSwatchesToLoad();
// });

// // ✅ Also fallback after any AJAX call
// $(document).ajaxComplete(function () {
//   waitForSwatchesToLoad();
// });

// ✅ Swatch click logic
$(document).on(
  "click",
  ".card-wrapper .color-swatches .swatch-label",
  function () {
    var $label = $(this);
    var radio = $label.find(".swatch-radio");
    var selectedColor = $label.find(".swatch").attr("title");
    var variantId = radio.val();
    var $cardWrapper = $label.closest(".card-wrapper");

    var $productCardMobile = $cardWrapper.find(
      ".collection_mobile_cart.width_respornsive"
    );
    var $productCardDesktop = $cardWrapper.find(
      ".collection_mobile_cart.desktop_cart"
    );

    var productWishlistbutton = $cardWrapper.find(".wishlist_button");

    var $formMobile = $productCardMobile.find("form");
    var $formDesktop = $productCardDesktop.find("form");

    var $inputMobile = $formMobile.find("input[name='id']");
    var $inputDesktop = $formDesktop.find("input[name='id']");

    var $btnMobile = $productCardMobile.find(".adc--ctn");
    var $btnDesktop = $productCardDesktop.find(".adc--ctn");

    if (radio.length) {
      radio.prop("checked", true).trigger("change");

      if ($inputMobile.length) $inputMobile.val(variantId).trigger("change");
      if ($inputDesktop.length) $inputDesktop.val(variantId).trigger("change");

      if (productWishlistbutton.length) {
        productWishlistbutton.attr("data-product-variant-id", variantId);
        productWishlistbutton.attr(
          "data-selected-variant-value",
          selectedColor
        );
      }

      $btnMobile.prop("disabled", !variantId);
      $btnDesktop.prop("disabled", !variantId);

      $label.siblings().removeClass("active");
      $label.addClass("active");

      $cardWrapper.find(".selected_value").text(selectedColor);

      var productVariantsData = $cardWrapper
        .find("#product-variants-data")
        .text();
      if (productVariantsData) {
        console.log("Enter Image");
        try {
          var productVariants = JSON.parse(productVariantsData);
          var selectedVariant = productVariants.find((v) => v.id == variantId);

          if (selectedVariant && selectedVariant.variant_image?.length) {
            var primaryImage = selectedVariant.variant_image[0];
            var secondaryImage =
              selectedVariant.variant_image[2] || primaryImage;

            var $images = $cardWrapper.find(".media img");
            if ($images.length >= 2) {
              $images
                .eq(0)
                .attr("src", primaryImage)
                .attr("srcset", primaryImage);
              $images
                .eq(2)
                .attr("src", secondaryImage)
                .attr("srcset", secondaryImage);
            }
          }
        } catch (err) {
          console.error("Invalid productVariantsData JSON", err);
        }
      }
    }
  }
);

jQuery(function ($) {
  let swiperInstances = [];

  // Function to initialize Swiper
  function initializeSwiper() {
    if ($(window).width() <= 789) {
      // For mobile-sized screens
      $(".product__media-list").each(function (index) {
        let this_item = $(this);

        // Prevent duplicate initialization
        if (!this_item.hasClass("swiper-initialized")) {
          this_item.addClass(
            "swiper-container swiper-initialized customswiper-" + index
          );

          // Wrap existing content in swiper-wrapper if not already wrapped
          if (!this_item.find(".swiper-wrapper").length) {
            this_item.wrapInner('<div class="swiper-wrapper"></div>');
          }

          // Convert direct child elements into swiper-slide
          this_item.find(".swiper-wrapper > *").each(function () {
            $(this).wrap('<div class="swiper-slide"></div>');
          });

          // Add Swiper pagination
          this_item.append('<div class="swiper-pagination"></div>');
          this_item.append('<div class="swiper-button-next"></div>');
          this_item.append('<div class="swiper-button-prev"></div>');

          // Initialize Swiper
          let swiper = new Swiper(".customswiper-" + index, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 1,
            pagination: { el: ".swiper-pagination", clickable: true },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });

          // Save swiper instance for later destroy
          swiperInstances.push(swiper);
        }
      });
    }
  }

  // Function to destroy all Swipers
  function destroySwipers() {
    swiperInstances.forEach((swiper) => swiper.destroy(true, true));
    swiperInstances = []; // Reset the array of Swiper instances
    $(".swiper-container").removeClass("swiper-initialized"); // Remove swiper initialization class
  }

  // Main process to change variant images and initialize Swiper
  function processVariantCustom() {
    if ($(".product").length) {
      let selected_variant = $(".variant-selects input:checked").attr(
        "data-variant-id"
      );
      console.log("id:", selected_variant);

      if (!selected_variant) return;

      if (p_variants && p_variants.length > 0) {
        console.log("step: 4", p_variants);

        $.each(p_variants, function (e3, i3) {
          console.log("step: 4", i3);
          if (i3.id == selected_variant) {
            console.log("step: 4", i3);
            let variant_images = "";

            if (i3.variant_image) {
              // Fade-out old images
              $(".product__media-list").css({
                opacity: 0,
                transition: "opacity 0.5s",
              });

              setTimeout(function () {
                // Ensure fade-out effect is applied before updating images
                if ($(window).width() <= 786) {
                  variant_images += '<div class="swiper-wrapper">';

                  $.each(i3.variant_image, function (i2, media) {
                    if (typeof media === "string") {
                      variant_images += `
                        <div class="swiper-slide fade-effect">
                        <li class="product__media-item grid__item animate--fade-in">
                        <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.8366013071895425;
    --preview-ratio: 0.8366013071895425;">
                        <div class="product__media media ">
                          <img src="${media}" alt="Product Image">
                        </div></div></li></div>`;
                    } else if (media.media_type === "video" && media.sources) {
                      variant_images += `
                        <div class="swiper-slide fade-effect">
                        <li class="product__media-item grid__item animate--fade-in">
                        <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 0.8366013071895425;
    --preview-ratio: 0.8366013071895425;">
                        <div class="product__media media ">
                          <video autoplay loop muted playsinline>`;
                      $.each(media.sources, function (index, source) {
                        if (source.mime_type.includes("video")) {
                          variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                        }
                      });
                      variant_images += `Your browser does not support the video tag.</video></div></div></li></div>`;
                    }
                  });

                  variant_images += "</div>";

                  $(".product__media-list").html(variant_images);
                  $(".product__media-list")
                    .addClass("swiper-container")
                    .append('<div class="swiper-pagination"></div>')
                    .append('<div class="swiper-button-next"></div>')
                    .append('<div class="swiper-button-prev"></div>');

                  // Destroy existing Swiper instance if already initialized
                  destroySwipers();

                  // Initialize new Swiper instance
                  setTimeout(function () {
                    initializeSwiper(); // Call initializeSwiper for the new images
                    console.log("Swiper initialized successfully!");
                  }, 200);
                } else {
                  // For desktop (non-Swiper version)
                  $.each(i3.variant_image, function (i2, media) {
                    if (typeof media === "string") {
                      variant_images += `
                        <li class="product__media-item grid__item fade-effect">
                          <img src="${media}" alt="Product Image">
                        </li>`;
                    } else if (media.media_type === "video" && media.sources) {
                      variant_images += `
                        <li class="product__media-item grid__item fade-effect"> 
                        <div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height">
                        <deferred-media class="deferred-media media media--transparent">
                          <video autoplay loop muted playsinline>`;
                      $.each(media.sources, function (index, source) {
                        if (source.mime_type.includes("video")) {
                          variant_images += `<source src="${source.url}" type="${source.mime_type}">`;
                        }
                      });
                      variant_images += `Your browser does not support the video tag.</video></deferred-media></div></li>`;
                    }
                  });

                  $(".product__media-list").html(variant_images);
                }

                // Fade-in the updated images
                $(".product__media-list").css({
                  opacity: 1,
                  transition: "opacity 0.5s",
                });
              }, 300);
            }
          }
        });
      }
    }
  }

  // Call processVariantCustom on page load
  processVariantCustom();

  // Event handler for variant change
  $(document).on("change", ".variant-selects input:checked", function () {
    processVariantCustom();
  });

  // Debounced resize function to handle resizing and reinitializing Swiper
  let resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      processVariantCustom();
    }, 500); // Delay to avoid firing too often
  });
});

$(document).on("click", ".wishlist_button", function () {
  console.log("wishlist button click");
  const $button = $(this);
  const pdpData = {
    productTitle: $button.data("product-title"),
    productImg: $button.data("product-img"),
    productPrice: $button.data("product-price"),
    productUrl: $button.data("product-url"),
    productId: $button.data("product-id"), // ✅ Product ID
    productVariant: $button.data("product-variant-id"), // ✅ Product Variant ID
    productVariantValue: $button.data("selected-variant-value"),
  };

  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  const isAlreadyInWishlist = wishlistData.some(
    (item) => item.productTitle === pdpData.productTitle
  );

  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    $button
      .find(".wishlist_button_svg path")
      .attr("fill", "#000")
      .attr("stroke", "#000");
  } else {
    wishlistData = wishlistData.filter(
      (item) => item.productTitle !== pdpData.productTitle
    );
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    $button.find(".wishlist_button_svg path").attr("fill", "none");
  }

  // ✅ Wishlist Count Update Karega
  updateWishlistCount();
  displayWishlist();
});

function updateWishlistCount() {
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];

  let wishlistCountDesktop = $(
    ".header__icon.only_desktop_view .wishlist-total-count"
  );
  let wishlistCountMobile = $(
    ".header__icon.only_mobile_view .wishlist-total-count"
  );

  if (wishlistCountDesktop.length) {
    wishlistCountDesktop.text(wishlistData.length);
    wishlistCountDesktop.attr("data-total", wishlistData.length);
  }

  if (wishlistCountMobile.length) {
    wishlistCountMobile.text(wishlistData.length);
    wishlistCountMobile.attr("data-total", wishlistData.length);
  }
}

function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  const $wishlistBlock = $(".js-wishlistBlock");
  $wishlistBlock.removeClass("is-loading");

  if (wishlistData.length === 0) {
    $wishlistBlock
      .addClass("is-empty")
      .html(
        "<div><img src='https://cdn.shopify.com/s/files/1/0898/9773/0346/files/MicrosoftTeams-.1-video.png?v=1744275795' alt=''></div>"
      );
  } else {
    $wishlistBlock.removeClass("is-empty").html(
      wishlistData
        .map(
          (item) => `
        <div class="wishlist-product__list">
          <div class="c-product">
            <a href="${item.productUrl}">
              <img src="${item.productImg}" alt="${item.productTitle}">
              
            </a>
            <div class="remove_wishlist" data-product-title="${item.productTitle}">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3742 5.88867C18.3567 5.88867 18.3305 5.88867 18.3042 5.88867C13.6755 5.42492 9.05547 5.24992 4.47922 5.71367L2.69422 5.88867C2.32672 5.92367 2.00297 5.66117 1.96797 5.29367C1.93297 4.92617 2.19547 4.61117 2.55422 4.57617L4.33922 4.40117C8.99422 3.92867 13.7105 4.11242 18.4355 4.57617C18.7942 4.61117 19.0567 4.93492 19.0217 5.29367C18.9955 5.63492 18.7067 5.88867 18.3742 5.88867Z" fill="#2F2E2C"/>
<path d="M7.43815 5.005C7.40315 5.005 7.36815 5.005 7.3244 4.99625C6.9744 4.935 6.7294 4.59375 6.79065 4.24375L6.98315 3.0975C7.12315 2.2575 7.31565 1.09375 9.3544 1.09375H11.6469C13.6944 1.09375 13.8869 2.30125 14.0182 3.10625L14.2106 4.24375C14.2719 4.6025 14.0269 4.94375 13.6769 4.99625C13.3181 5.0575 12.9769 4.8125 12.9244 4.4625L12.7319 3.325C12.6094 2.56375 12.5831 2.415 11.6556 2.415H9.36315C8.43565 2.415 8.41815 2.5375 8.2869 3.31625L8.08565 4.45375C8.03315 4.7775 7.75315 5.005 7.43815 5.005Z" fill="#2F2E2C"/>
<path d="M13.3081 19.9056H7.69061C4.63686 19.9056 4.51436 18.2169 4.41811 16.8519L3.84936 8.04064C3.82311 7.68189 4.10311 7.36689 4.46186 7.34064C4.82936 7.32314 5.13561 7.59439 5.16186 7.95314L5.73061 16.7644C5.82686 18.0944 5.86186 18.5931 7.69061 18.5931H13.3081C15.1456 18.5931 15.1806 18.0944 15.2681 16.7644L15.8369 7.95314C15.8631 7.59439 16.1781 7.32314 16.5369 7.34064C16.8956 7.36689 17.1756 7.67314 17.1494 8.04064L16.5806 16.8519C16.4844 18.2169 16.3619 19.9056 13.3081 19.9056Z" fill="#2F2E2C"/>
<path d="M11.9528 15.0938H9.03906C8.68031 15.0938 8.38281 14.7962 8.38281 14.4375C8.38281 14.0788 8.68031 13.7812 9.03906 13.7812H11.9528C12.3116 13.7812 12.6091 14.0788 12.6091 14.4375C12.6091 14.7962 12.3116 15.0938 11.9528 15.0938Z" fill="#2F2E2C"/>
<path d="M12.6875 11.5938H8.3125C7.95375 11.5938 7.65625 11.2962 7.65625 10.9375C7.65625 10.5788 7.95375 10.2812 8.3125 10.2812H12.6875C13.0462 10.2812 13.3438 10.5788 13.3438 10.9375C13.3438 11.2962 13.0462 11.5938 12.6875 11.5938Z" fill="#2F2E2C"/>
</svg>

            </div>
            <h3 class="c-product__title card__heading h5">
              <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
            </h3>
            <p class="price-item price-item--sale price-item--last">${item.productPrice}</p>
            <p class="variant_value">Color: ${item.productVariantValue}</p>
            
            <div class="remove_move_cart">
            
            <div class="move_to_cart" 
                data-product-id="${item.productId}" 
                data-product-variant-id="${item.productVariant}" 
                data-product-title="${item.productTitle}">
               Move to Cart
            </div>
          </div>
          </div>
          
        </div>
      `
        )
        .join("")
    );
  }
}

$(document).on("click", ".remove_wishlist", function (event) {
  const productTitle = $(this).data("product-title");
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlistData = wishlistData.filter(
    (item) => item.productTitle !== productTitle
  );
  localStorage.setItem("wishlist", JSON.stringify(wishlistData));
  updateWishlistCount();
  displayWishlist();
  updateCartCount();
});

$(document).on("click", ".move_to_cart", function (event) {
  console.log("move to cart button click");
  const $button = $(this);
  const productVariantId = $button.data("product-variant-id");
  const productTitle = $button.data("product-title");

  $button.text("Moving...").attr("aria-disabled", "true");

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: productVariantId,
      quantity: 1,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // ✅ Wishlist Se Product Remove Karega
      let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
      wishlistData = wishlistData.filter(
        (item) => item.productTitle !== productTitle
      );
      localStorage.setItem("wishlist", JSON.stringify(wishlistData));
      displayWishlist();
      updateWishlistCount();
      updateCartCount();

      // ✅ Update Cart Drawer
      fetchCartDrawer();

      // ✅ Open Cart Drawer
      setTimeout(() => {
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("body").addClass("overflow-hidden");
      }, 500);
    })
    .finally(() => {
      $button.textContent = "Move to Cart";
      $button.removeAttr("aria-disabled");
    });
});

function fetchCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((html) => {
      cartDrawer.innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector("cart-drawer").innerHTML;
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const wishlistButtons = document.querySelectorAll(".wishlist_button");
  const wishlistCount = document.querySelector(".wishlist-total-count");
  const cartDrawer = document.querySelector("cart-drawer");
  const wishlistBlock = document.querySelector(".js-wishlistBlock");

  // ✅ Page load pe wishlist button active/inactive karega
  wishlistButtons.forEach((button) => {
    const productTitle = button.getAttribute("data-product-title");
    const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];

    // ✅ Check karega product wishlist me hai ya nahi
    const isAlreadyInWishlist = wishlistData.some(
      (item) => item.productTitle === productTitle
    );
    if (isAlreadyInWishlist) {
      button
        .querySelector(".wishlist_button_svg path")
        .setAttribute("fill", "#000");
      button
        .querySelector(".wishlist_button_svg path")
        .setAttribute("stroke", "#000");
    }
  });

  // ✅ Page Refresh Pe Wishlist Count Show Karega
  updateWishlistCount();
  if (document.body.classList.contains("custom-wishlist")) {
    showLoading();

    setTimeout(() => {
      // ✅ Wishlist Data Load Karega
      displayWishlist();
    }, 3000); // 1.5 sec delay for loading effect

    function showLoading() {
      wishlistBlock.classList.add("is-loading");
      wishlistBlock.innerHTML = `
      <div class="wishlist-loading">
        <img src="https://cdn.shopify.com/s/files/1/0857/2085/8938/files/Animation_-_1741843753530.gif?v=1741843804" alt="Loading...">
      </div>
    `;
    }
  }
});

function updateCartCount() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      $(".cart-count-bubble span").text(cart.item_count);
    },
  });
}

$(document).on("click", function (event) {
  if (!$(event.target).closest("cart-drawer").length) {
    $("cart-drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  }
});
